import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { formatAbsoluteDate, formatAbsoluteDateTime } from './time'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function formatDate(date: Date | string | number): string {
  return formatAbsoluteDate(date)
}

export function formatDateTime(date: Date | string | number): string {
  return formatAbsoluteDateTime(date, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
